import React from 'react';
import formatNumber from '../../../helpers/NumberFormat';
import "./ReportsPanel.scss"

export default function ReportsPanelComponent({ isMobile, mainProps, showSidebar }) {
    const { main, mainLoading, mainError } = mainProps;

    const getDailyLimit = (balance) => {
        if (balance <= 5000) return 50000;
        if (balance <= 10000) return 50000;
        if (balance <= 25000) return 50000;
        if (balance <= 50000) return 50000;
        if (balance <= 100000) return 100000;
        return Math.ceil(balance / 50000) * 50000;
    };

    const dailyLimit = getDailyLimit(main?.user?.balance || 0);

    return (
        <>
            <div
                className="container-fluid bg-col transition-width"
                style={
                    !isMobile
                        ? {
                            width: showSidebar ? 'calc(100% - 332px)' : '100%',
                            marginLeft: 0,
                            marginRight: 'auto',
                            transition: showSidebar ? 'width 0.3s ease-in-out' : 'width 0.16s ease-in-out'
                        } : {}
                }
            >
                <div className="row p-3 reports-panel" style={{ borderBottom: "2px solid #EFEFEF" }}>
                    <h5 className="mb-5 mt-2" style={{ fontWeight: "500" }}>REPORT PANEL</h5>
                    <div className="col-md-12 mb-3" style={{ borderBottom: "2px solid #EFEFEF" }}></div>
                    <div className="col-md-12" >
                        <h6 style={{ fontSize: "18px", fontWeight: "600" }}>Management of funds transfer</h6>
                        <p className='text-muted'>This section summarizes the daily and monthly limits for the transfer on the various reports linked to online channels and where possible allows you to make a request to our specialist to request changes.</p>
                        <p className='text-muted'>
                            As part of our commitment to supporting a wide range of financial needs, Banque Artesia Nederland N.V. allows high-value transfers that exceed standard daily limits under specific conditions. These transfers are essential for clients engaged in business operations, property transactions, investment activities, or other verified financial obligations that require timely movement of large funds.
                        </p>
                        <p className='text-muted'>
                            To ensure the highest levels of security and regulatory compliance, all such transactions are subject to enhanced multi-factor authentication, manual review, and approval by our internal risk and compliance teams. This approach allows us to balance flexibility with financial integrity, providing our clients with secure, efficient access to their capital when it matters most.
                        </p>
                        <div className="table-responsive mt-5">
                            <table className="table table-bordered table-hover">
                                <thead className="table-head">
                                    <tr className="py-3">
                                        <th style={{ width: "40%" }}>Ratio</th>
                                        <th className="text-end" style={{ width: "20%" }}>Single Transfer Limit</th>
                                        <th className="text-end" style={{ width: "20%" }}>Daily Limit</th>
                                        <th className="text-end" style={{ width: "20%" }}>Monthly Limit</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className='trClass'>
                                        <td>
                                            Current account no. <strong>{main?.user?.detail?.account_number?.replace(/^.*?-/, '')}</strong> in the name of <strong>{main?.user?.first_name?.toUpperCase()} {main?.user?.last_name?.toUpperCase()}</strong>
                                        </td>

                                        <td>
                                            <div className="d-flex flex-column align-items-end text-end gap-5">
                                                <div>
                                                    <div className="fw-bold">{formatNumber(dailyLimit)} €*</div>
                                                    <div>(Ordinary SEPA)</div>
                                                </div>
                                                <div>
                                                    <div className="fw-bold">{formatNumber(dailyLimit)} €*</div>
                                                    <div>(Urgent)</div>
                                                </div>
                                                <div>
                                                    <div className="fw-bold">{formatNumber(dailyLimit)} €*</div>
                                                    <div>(Instant)</div>
                                                </div>
                                            </div>
                                        </td>

                                        <td className="text-end">
                                            <div className="fw-bold">Daily remaining**</div>
                                            <div className="fw-bold">{formatNumber(dailyLimit)} €</div>
                                            <div>Set limit</div>
                                            <div>{formatNumber(0)} €</div>
                                        </td>

                                        <td className="text-end">
                                            <div className="fw-bold">Monthly remaining**</div>
                                            <div className="fw-bold">{formatNumber(dailyLimit * 2)} €*</div>
                                            <div>Set limit</div>
                                            <div>{formatNumber(0)} €</div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className='text-muted my-5' style={{ fontSize: "12px" }}>
                            <p className='mb-1'>*The maximum amount per single transfer cannot be changed.</p>
                            <p>**The Remaining amount represents the maximum you’re allowed to transfer this month, based on all transfers made since the beginning of the month.</p>
                        </div>
                    </div>
                    <div className="col-md-6 p-0">
                    </div>
                </div>
            </div >
        </>
    );
}